import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PieChartModule } from 'rev-shared/ui/dataVisualization/pieChart/PieChart.Module';

import { TranslateModule } from '@ngx-translate/core';
import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { VbDropdownMenuModule } from 'rev-shared/ui/dropdown-menu/VbDropdownMenu.Module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { VbRadioBtnModule } from 'rev-shared/ui/radio/VbRadioBtn.Module';
import { CheckboxAngularModule } from 'rev-shared/ui/checkbox/CheckboxAngular.Module';

import { IPollAnswer } from 'rev-portal/scheduledEvents/polls/Polls.Contract';
import { VbPollCardComponent } from './VbPollCard.Component';

@Component({
	selector: 'vb-attendee-poll-card',
	templateUrl: './VbAttendeePollCard.Component.html',
	imports: [
		BsDropdownModule,
		ButtonsAngularModule,
		CommonModule,
		CheckboxAngularModule,
		FormsModule,
		PieChartModule,
		TranslateModule,
		VbDropdownMenuModule,
		VbRadioBtnModule
	],
	host: {
		'[class.poll-card]': 'true'
	},
	styleUrls: ['./VbPollCard.ng.less'],
})
export class VbAttendeePollCardComponent extends VbPollCardComponent {
	public get enablePollSubmit(): boolean {
		return !!this.poll?.answers?.some(answer => !!answer.checked) && !this.poll?.responseSubmitted;
	}

	public vote(): void {
		const answers = (this.poll.answers || []).map(answer => !!answer.checked);

		this.poll.answer(answers);
		this.poll.responseSubmitted = true;
	}

	public onAnswerClick(answer: IPollAnswer): void {
		if (!this.poll.multipleChoice) {
			(this.poll.answers || []).forEach(a => a.checked = a === answer);
			this.poll.selectedAnswer = answer.text;
		}

		this.poll.responseSubmitted = false;
	}
}
